import React from 'react';
import { Button } from 'reactstrap';

/**
 * Tahsilat ekranlarının üst şeridi: breadcrumb + ikon + başlık/alt başlık, sağda
 * "Ödeme Linki Oluştur".
 *
 * Buton KASITLI olarak korunmuştur: tasarım taslaklarında yoktu ama mevcut üründe
 * bulunuyor ve kaldırılmaması istendi. Firma bilgisi yokken (companyId boş) link
 * oluşturulamayacağı için devre dışı kalır.
 */
const PaymentPageHeader = ({ meta, actionWord, onCreateLink, createLinkDisabled }) => (
    <div className="pay-header">
        <ol className="breadcrumb pay-breadcrumb">
            <li className="breadcrumb-item">{actionWord}</li>
            <li className="breadcrumb-item active">{meta.title}</li>
        </ol>

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div className="d-flex align-items-center gap-3">
                <div className="pay-header-icon">
                    <i className={`bx ${meta.icon}`} />
                </div>
                <div>
                    <h4 className="mb-1">{meta.title}</h4>
                    <small className="text-muted">{meta.subtitle}</small>
                </div>
            </div>

            {onCreateLink && (
                <Button
                    color="secondary"
                    className="btn-rounded"
                    onClick={onCreateLink}
                    disabled={createLinkDisabled}
                    title={createLinkDisabled ? 'Önce firma bilgisi gerekli' : ''}
                >
                    Ödeme Linki Oluştur
                </Button>
            )}
        </div>
    </div>
);

export default PaymentPageHeader;
